import { AbstractControl, FormGroup } from "@angular/forms";
import { ProfileMapper } from "./profile-mapper";
import { BaseComponent } from "src/app/shared/base/BaseComponent";
import { TranslateService } from "@ngx-translate/core";

export class BaseProfileComponent extends BaseComponent{
    form: FormGroup = new FormGroup({});
    showError: boolean = false;
    showSuccess: boolean = false;
    errorMessageKey: string;
    successMessageKey: string;

    constructor(
        translateService: TranslateService,
        protected _mapper: ProfileMapper){
        super(translateService);
    }

    protected setFormValue(value: any){
        type ObjectKey = keyof typeof value;
        Object.keys(this.form.controls).forEach((key) => {
            if (value[key] instanceof Date) {
                this.form.controls[key].setValue(this._mapper.convertToDisplayDate(value[key as ObjectKey]));
            }
            else{
                this.form.controls[key].setValue(value[key as ObjectKey]);
            }
        });
    }

    protected focusOnError(){
        setTimeout(() => {
            var tabs = document.getElementsByClassName("collapse");
            for(var i=0; i<tabs.length;i++){
                tabs[i].classList.remove("show");
            }
            document.querySelector('.is-invalid').closest(".collapse")?.classList.add("show"); 
        });
    }

    protected displayError(key: string){
        this.showError = true;
        this.errorMessageKey = key? `UserProfile.Errors.${key}`: "UserProfile.Errors.GeneralError";
        document.querySelector("body").scrollIntoView();
    }

    protected displaySuccess(key: string){
        this.showSuccess = true;
        this.successMessageKey = key ? `UserProfile.${key}` : "UserProfile.SuccessMessage";
        document.querySelector("body").scrollIntoView();
    }

    protected resetForm(exceptControls: string[] = []){
        Object.keys(this.form.controls).forEach((key) => {
            if (exceptControls.indexOf(key) >= 0) return;
            ((this.form.controls as any)[key] as AbstractControl).reset();
        });
    }
}